import qs from "query-string";
import {
  ParamKeyValuePair,
  useLocation,
  useSearchParams,
} from "react-router-dom";

export const useSetQueryStringFilter = (defaultInit: ParamKeyValuePair[]) => {
  let [, setSearchParams] = useSearchParams(defaultInit);

  const location = useLocation();
  const queryParam = qs.parse(location.search);

  const setQueryStringFilter = (queryKey: string, value: string) => {
    const newQueryParam = {
      ...queryParam,
      [queryKey]: value,
    };

    setSearchParams(qs.stringify(newQueryParam), { replace: true });
  };

  return setQueryStringFilter;
};
